export const GREEN = '#28B463'
export const TURQUOISE = '#48C9B0'
export const RED = '#E74C3C'
export const BLUE = '#2E86C1'
export const ORANGE = '#FFA500'